import {parallel, sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {IdleUIAct} from '@gongxigames/framework/slotV2/ui/acts/IdleUIAct';
import {WaitForRoundStartAct} from '@gongxigames/framework/slotV2/ui/acts/WaitForRoundStartAct';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {BuyFeatureButtonEnableUIAct} from '@gongxigames/framework/slotV2/ui/acts/BuyFeatureButtonEnableUIAct';
import {BuyFeatureButtonDisableUIAct} from '@gongxigames/framework/slotV2/ui/acts/BuyFeatureButtonDisableUIAct';
import {BuyFeatureButtonShowUIAct} from '@gongxigames/framework/slotV2/ui/acts/BuyFeatureButtonShowUIAct';
import {StartHoldForTurboLabelUIAct} from '@gongxigames/framework/slotV2/ui/acts/StartHoldForTurboLabelUIAct';
import {BuyFeatureFinishedUIAct} from '@gongxigames/framework/slotV2/ui/acts/BuyFeatureFinishedUIAct';

export class IdleUIState extends UIState {
    public static readonly ID = 'IdleUIState';

    public setAct(): void {
        this.act = sequence([
            parallel([
                WaitForRoundStartAct,
                IdleUIAct,
                StartHoldForTurboLabelUIAct,
                BuyFeatureButtonShowUIAct,
                BuyFeatureButtonEnableUIAct,
                BuyFeatureFinishedUIAct
            ]),
            BuyFeatureButtonDisableUIAct
        ]);
    }
}